export default function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-array/src/ascending.js
// module id = 9
// module chunks = 0